import React from "react"
import { handleDayOfMonth, handleHourAndMinutes, handleMonthString } from "../../../utils/Functions"
import { AppointmentStatus } from "../../../utils/enums/AppointmentStatus"
import { Appointment } from "../components/Appointment"
import "./css/OldAppointmentWidget.css"

interface Props {
    appointment: Appointment,
}

const OldAppointmentWidget: React.FC<Props> = ({
    appointment,
}) => {
    return (
        <div className="old-appointment-widget-container">
            <div className="old-appointment-widget-internal-container">
                <div className="old-appointment-widget-upper-element-container">
                    <div className="old-appointment-widget-upper-element-heading">
                        Videoconsulto
                    </div>
                    <div className="old-appointment-widget-upper-element-date">
                        <span>{handleDayOfMonth(appointment.date)} {handleMonthString(appointment.date)} <span className="old-appointment-widget-regular-font">{handleHourAndMinutes(appointment.date)}</span></span>
                    </div>
                </div>
                <div className="old-appointment-widget-bottom-element-container">
                    <div className="old-appointment-widget-bottom-left-element">
                        <div className="old-appointment-widget-bottom-element-expert-position">
                            {appointment.expert?.position}
                        </div>
                        <div className="old-appointment-widget-bottom-element-name">
                            {appointment.expert?.name} {appointment.expert?.familyName}
                        </div>
                        <div className="old-appointment-widget-bottom-element-expert-role">
                            {appointment.expert?.role}
                        </div>
                    </div>
                    <div className="old-appointment-widget-bottom-element-status-container">
                        <div className={appointment.status === AppointmentStatus.Active ? "old-appointment-widget-bottom-element-status-text" : "old-appointment-widget-bottom-element-status-text-canceled"}>
                            {appointment.status === AppointmentStatus.Active ? "Passato" : "Cancellato"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OldAppointmentWidget
